<template>
  <span
    v-if="badge"
    :class="rootClass"
    :aria-label="badge.label"
  >{{ badge.label }}</span>
</template>

<script>
import { computed } from 'vue'
import { getExamPromoBadge } from '@/utils/examPricing'

export default {
  name: 'ExamPromoBadge',
  props: {
    exam: { type: Object, default: null },
    /** card-ribbon：列表卡片右上角斜角；thumb：缩略图左上角；cover：详情封面；inline：行内胶囊 */
    variant: {
      type: String,
      default: 'card-ribbon',
      validator: (v) => ['card-ribbon', 'thumb', 'cover', 'inline'].includes(v)
    }
  },
  setup(props) {
    const badge = computed(() => getExamPromoBadge(props.exam))
    const rootClass = computed(() => {
      if (!badge.value) return []
      return [
        'exam-promo-badge',
        `exam-promo-badge--${props.variant}`,
        `exam-promo-badge--${badge.value.type}`
      ]
    })
    return { badge, rootClass }
  }
}
</script>

<style scoped>
/* 列表卡片：右上角斜角丝带 */
.exam-promo-badge--card-ribbon {
  position: absolute;
  top: 14px;
  right: -38px;
  z-index: 5;
  width: 140px;
  padding: 6px 0;
  text-align: center;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #fff;
  transform: rotate(45deg);
  pointer-events: none;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
}

.exam-promo-badge--card-ribbon.exam-promo-badge--free {
  background: linear-gradient(90deg, #67c23a, #529b2e);
  box-shadow: 0 3px 12px rgba(103, 194, 58, 0.4);
}

.exam-promo-badge--card-ribbon.exam-promo-badge--limited-free {
  background: linear-gradient(90deg, #ff4d4f, #ff7a45, #ffa940);
  box-shadow: 0 3px 12px rgba(255, 77, 79, 0.45);
}

.exam-promo-badge--card-ribbon.exam-promo-badge--limited-promo {
  background: linear-gradient(90deg, #e6a23c, #f5a623);
  box-shadow: 0 3px 12px rgba(230, 162, 60, 0.4);
}

/* 缩略图左上角 */
.exam-promo-badge--thumb {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
  border-radius: 0 0 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.exam-promo-badge--thumb.exam-promo-badge--free {
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%);
}

.exam-promo-badge--thumb.exam-promo-badge--limited-free {
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7a45 45%, #ffa940 100%);
  box-shadow: 0 4px 16px rgba(255, 77, 79, 0.45);
}

.exam-promo-badge--thumb.exam-promo-badge--limited-promo {
  background: linear-gradient(90deg, #e6a23c, #f5a623);
}

/* 详情封面 */
.exam-promo-badge--cover {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2;
  padding: 10px 18px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #fff;
  border-radius: 10px;
}

.exam-promo-badge--cover.exam-promo-badge--free {
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%);
  box-shadow: 0 6px 20px rgba(103, 194, 58, 0.45);
}

.exam-promo-badge--cover.exam-promo-badge--limited-free {
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7a45 50%, #ffa940 100%);
  box-shadow: 0 6px 20px rgba(255, 77, 79, 0.5);
}

.exam-promo-badge--cover.exam-promo-badge--limited-promo {
  background: linear-gradient(135deg, #e6a23c 0%, #f5a623 100%);
  box-shadow: 0 6px 20px rgba(230, 162, 60, 0.45);
}

/* 详情 meta 行内 */
.exam-promo-badge--inline {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #fff;
  border-radius: 8px;
}

.exam-promo-badge--inline.exam-promo-badge--free {
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%);
  box-shadow: 0 4px 14px rgba(103, 194, 58, 0.35);
}

.exam-promo-badge--inline.exam-promo-badge--limited-free {
  background: linear-gradient(90deg, #ff4d4f, #ff7a45, #ffa940);
  box-shadow: 0 4px 14px rgba(255, 77, 79, 0.4);
}

.exam-promo-badge--inline.exam-promo-badge--limited-promo {
  background: linear-gradient(90deg, #e6a23c, #f5a623);
  box-shadow: 0 4px 14px rgba(230, 162, 60, 0.35);
}
</style>
